module.exports = __webpack_public_path__ + "img/banner2_4_th.77becf08.png";